import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { useLocale } from '../contexts/LocaleProvider';
import ContactUsHome from './salesAndResourcesPage/ContactUsHome';
import { GeographicRegionsProvider } from '../graphql/pimcore/modules/geographic/contexts/GeographicRegionsProvider';
import pimcoreClient from '../graphql/pimcore/apollo/pimcoreClient';
import { DistributorsProvider } from '../graphql/pimcore/modules/contacts/contexts/DistributorsProvider';
import { OfficesProvider } from '../graphql/pimcore/modules/contacts/contexts/OfficesProvider';
import { RepresentativesProvider } from '../graphql/pimcore/modules/contacts/contexts/RepresentativeProvider';
import { useSalesAndResourcesContactPointsContent } from '../graphql/pimcore/modules/siteContent/hooks/useSalesAndResourcesContactPointsContent';
import DebouncedLoader from './common/DebouncedLoader';

const ContactUsPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useSalesAndResourcesContactPointsContent();

    if (error) {
        return <div>Error loading application content.</div>;
    }

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered={true}>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <GeographicRegionsProvider apolloClient={pimcoreClient}>
                    <DistributorsProvider apolloClient={pimcoreClient}>
                        <OfficesProvider apolloClient={pimcoreClient}>
                            <RepresentativesProvider apolloClient={pimcoreClient}>
                                <Box
                                    width="100%"
                                    component="main"
                                    sx={{
                                        padding: 0,
                                        flexGrow: 0,
                                        p: 0,
                                    }}
                                >
                                    <ContactUsHome contentTree={contentTree} />
                                </Box>
                            </RepresentativesProvider>
                        </OfficesProvider>
                    </DistributorsProvider>
                </GeographicRegionsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default ContactUsPage;
